export default "__VITE_ASSET__CpEAYUOZ__"